/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateSiteResponseDataFromJSON, CreateSiteResponseDataToJSON } from './CreateSiteResponseData';
export function CreateSiteResponseFromJSON(json) {
    return CreateSiteResponseFromJSONTyped(json, false);
}
export function CreateSiteResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: CreateSiteResponseDataFromJSON(json['data'])
    };
}
export function CreateSiteResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: CreateSiteResponseDataToJSON(value.data)
    };
}
